import Parse from "parse";
import { filterKeys, getClassName } from "./ParseConfiguration";
import { addImageIfExists } from "./ParseConfiguration";
import { handleError } from "./ErrorHandler.ts";
import { setLimit } from "./ParseConfiguration";
import { GuestModel, Guest } from "../Models/Guest.ts";


const GUESTS_TABLE: any = getClassName("Guest")


export async function getGuests(): Promise<GuestModel[]> {
  try {
    const query = new Parse.Query(GUESTS_TABLE)
    query.descending("createdAt")
    const count = await query.count()
    setLimit(query, count)
    const result = await query.find()

    return result.map((parseObject: any) =>
      Guest.convertFromParseObject(parseObject)
    )
  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function addOrUpdateGuest(newGuest: GuestModel, avatar?: string): Promise<void> {
  try {
    const Guest = GUESTS_TABLE
    const guest = new Guest()
    Object.entries(newGuest)
      .filter((key) => !filterKeys.includes(key[0]))
      .forEach((key) => {
        guest.set(key[0], key[1])
      })
    await addImageIfExists(guest, avatar, "avatar")
    await guest.save()

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function deleteGuest(objectId: string): Promise<void> {
  try {
    const query = new Parse.Query(GUESTS_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      await result[0].destroy()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function getGuestById(objectId: string): Promise<GuestModel> {
  try {
    const query = new Parse.Query(GUESTS_TABLE)
    const parseObject = await query.get(objectId)
    const event = Guest.convertFromParseObject(parseObject)
    return event

  } catch (error) {
    handleError(error)
    throw error
  }
}
